// Centralized brand constants. Operator can rename the app by editing here
// (or by setting BRAND_NAME / BRAND_HANDLE env vars). Used in listing copy,
// emails, the App Bridge title, the support page, etc.

// The canonical public origin — the ONLY host that may appear in a canonical link,
// og:url, sitemap <loc>, robots Sitemap: directive, llms.txt, or JSON-LD url.
//
// Every one of those was hardcoded to the Railway subdomain across eight files, so
// quote-desk.app served the site while instructing every crawler that the
// authoritative copy lived at quote-desk-app-production.up.railway.app — i.e. we
// bought the domain and then de-indexed it. Measured 2026-08-09; see
// state/shelf-space/DOGFOOD-AUDIT.md. Keep this the single source of truth so the
// defect cannot come back one file at a time.
export const SITE_ORIGIN = process.env.SITE_ORIGIN ?? "https://quote-desk.app";

export const SOCIAL_IMAGE = {
  url: `${SITE_ORIGIN}/quote-desk-og.png`,
  width: "1200",
  height: "630",
  alt: "Quote Desk showing a B2B quote workflow built for Shopify",
} as const;

export const BRAND = {
  name: process.env.BRAND_NAME ?? "Quote Desk",
  handle: process.env.BRAND_HANDLE ?? "quote-desk",
  tagline: "B2B quotes, custom pricing, PO parsing, and AI counter-offers — every plan, not just Plus.",
  supportEmail: "info+support@legitimateapps.com",
  primaryColor: "#1f4cff",
  secondaryColor: "#16a34a",
} as const;
